import { BrandDTO } from './BrandDTO';

const MG_PRIS_SE_APP_KEY = 'mgpris2' as const;
const MG_PRIS_NO_APP_KEY = 'no-mgpris' as const;
export const mpeTenants = [MG_PRIS_NO_APP_KEY, MG_PRIS_SE_APP_KEY] as const;

export type MpeTenantKey = (typeof mpeTenants)[number];

interface AppTenantConfig {
  externalItemSource: 'NOBB' | 'FINFO';
  hasMainSupplier: boolean;
}

export class AppTenant {
  static readonly NORWAY = new AppTenant('NO', MG_PRIS_NO_APP_KEY, {
    externalItemSource: 'NOBB',
    hasMainSupplier: true,
  });
  static readonly SWEDEN = new AppTenant('SE', MG_PRIS_SE_APP_KEY, {
    externalItemSource: 'FINFO',
    hasMainSupplier: false,
  });

  readonly externalItemSource: AppTenantConfig['externalItemSource'];
  readonly hasMainSupplier: boolean;

  private constructor(
    public readonly countryCode: 'NO' | 'SE',
    public readonly tenantAppKey: MpeTenantKey,
    config: AppTenantConfig
  ) {
    this.externalItemSource = config.externalItemSource;
    this.hasMainSupplier = config.hasMainSupplier;
  }
}

export interface BrandProps {
  brandId: string;
  name: string;
  wholesaler: boolean;
  tenant: AppTenant;
}

export class Brand {
  brandId: string;
  name: string;
  wholesaler: boolean;
  tenant: AppTenant;

  constructor(props: BrandProps) {
    this.brandId = props.brandId;
    this.name = props.name;
    this.wholesaler = props.wholesaler;
    this.tenant = props.tenant;
  }

  static fromDto = (dto: BrandDTO, brandTenant: AppTenant) =>
    new Brand({
      brandId: dto.brandId,
      name: dto.name,
      wholesaler: dto.wholesaler,
      tenant: brandTenant,
    });
}
